// src/components/Header.tsx
import React from "react";
import { AppBar, Toolbar, Typography, IconButton, Box } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

interface HeaderProps {
  clubName: string;
  logoUrl: string;
  onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ clubName, logoUrl, onLogout }) => {
  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar>
        {/* Logo del club */}
        <Box
          component="img"
          src={logoUrl}
          alt={`${clubName} logo`}
          sx={{ height: 40, marginRight: 4 }}
        />
        {/* Nombre del club */}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          {clubName}
        </Typography>
        {/* Botón de cerrar sesión */}
        <IconButton color="inherit" onClick={onLogout}>
          <LogoutIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
